import { EVENT_BUS } from '@/model/event-bus';

 const NOTE_ON = 9, NOTE_OFF = 8;

 /**
 * Midi Input service
 */
class MidiWrapper {
    messages = [];
    meta = {};

    async init() {
        const midi = await navigator.requestMIDIAccess()
        this.input = midi.inputs.size
            ? midi.inputs.values().next().value
            : void (0);
        if (!this.input) {
            console.warn('No midi device found!');
            return;
        }
        midi.onstatechange = this.onStateChange.bind(this);
        this.input.onmidimessage = this.onMidiMessage.bind(this);
    }

    onMidiMessage(e) {
        const parsed = this.parseMidiMessage(e.data);
        if (parsed.command === NOTE_ON && parsed.velocity > 0) {
            EVENT_BUS.emit('MIDI_noteOn', parsed);
        } else if (parsed.command === NOTE_OFF || parsed.velocity === 0) {
            EVENT_BUS.emit('MIDI_noteOff', parsed);
        }
        this.messages.value = [parsed];
    }

    parseMidiMessage(data) {
        return {
            command: data[0] >> 4,
            channel: data[0] & 0xf,
            note: data[1],
            // piano notes are 21..108 A0 ... C8
            pianoNote: data[1] - 20,
            velocity: data[2] / 127
        }
    }

    onStateChange(e) {
        // console.debug('MIDI#onStateChange')
        this.meta.name = e.port.name;
        this.meta.manufacturer = e.port.manufacturer;
        this.meta.state = e.port.state;
        EVENT_BUS.emit('MIDI_onStateChange', this.meta);
    }
}

const instance = new MidiWrapper();

export async function initMidi() {
    return instance.init();
}

export const Midi = instance;